import { SHOW_LOADER, HIDE_LOADER } from './../constants/actionTypes'

export const showLoader = data => dispatch => {
  dispatch({
    type: SHOW_LOADER,
    data
  })
}

export const hideLoader = data => dispatch => {
  dispatch({
    type: HIDE_LOADER,
    data
  })
}
